<template>
  <el-row :gutter="10">
    <el-col :span="10">
      <page-yarn-table />
    </el-col>
    <el-col :span="14">
        <page-yarn-options-table/>
    </el-col>
  </el-row>
</template>
<script>
import PageYarnTable from './components/sample-table/index.vue'
import PageYarnOptionsTable from './components/yarn-options-table/index.vue'
export default {
  name: 'master-yarn',
  components: {
    PageYarnTable,
    PageYarnOptionsTable,
  },
}
</script>
